/**
 * @format
 */
import { ProofOfPaymentService } from '@/scripts/services/invoices/proof-of-payment-service.js';
import EventBus from '@/scripts/event-bus';

export const InvoiceProofOfPaymentServiceMixin = {
    methods: {
        refreshEvent() {
            EventBus.$emit('invoice:update');
        },

        handleUploadProofOfPayment({ file, accountId, invoiceId }) {
            const payload = {
                InvoiceId: Number(invoiceId),
                ProofUrl: file.file,
                FileName: file.name,
                FileMimeType: file.type,
                FileSize: file.size,
            };
            return ProofOfPaymentService.upload({ payload, accountId }).then(() => {
                this.refreshEvent();
            });
        },

        deleteProofOfPayment({ accountId, invoiceId }) {
            return ProofOfPaymentService.delete({ accountId, invoiceId }).then(() => {
                this.refreshEvent();
            });
        },

        dispatchProofOfPayment({ invoiceId, accountId }) {
            return new Promise((resolve, reject) => {
                ProofOfPaymentService.getByInvoiceId({ invoiceId, accountId })
                    .then(({ data: { data } }) => {
                        resolve(data);
                    })
                    .catch(reject);
            });
        },
    },
};
